<div
	class="order-item"
	id="root"
	role="listitem"
	[attr.aria-label]="(articleGroup.article.name | langObservable | async) + ' with ' + articleGroup.quantity + ' items'"
>
	<ion-row class="order-item-content">
		<ion-col *ngIf="cardTitle" size="12" class="ion-margin-bottom">
			<ion-card-title>{{ cardTitle }}</ion-card-title>
		</ion-col>
		<!-- Product image -->
		<ion-col size="4" class="img_section">
			<ion-img
				[src]="articleGroup.article.assets.medium"
				[attr.alt]="'Image of ' + (articleGroup.article.name | langObservable | async)"
				class="product-image"
			>
			</ion-img>
		</ion-col>

		<!-- Product details -->
		<ion-col size="8">
			<!-- Product name and action buttons -->
			<ion-row>
				<ion-col size="7" class="center-vertical">
					<h2 class="order-article-name">
						{{ articleGroup.article.name | langObservable | async }}
					</h2>
				</ion-col>
				<ion-col size="7" *ngIf="showSinglePrice">
					<p>{{ numberToCurrency(articleGroup.article.price, order.currency) }}</p>
				</ion-col>
				<ion-col size="5">
					<div class="icons_block">
						<div class="edit_section">
							<!-- Edit button -->
							<button
								*ngIf="isEditable() && articleGroup.article.groups.length > 0"
								class="edit-btn"
								(click)="edit()"
								aria-label="Edit item"
								tabindex="0"
							>
								<ion-icon src="../../../assets/dean_and_david/edit_article.svg" aria-hidden="true"> </ion-icon>
								<span class="visually-hidden">Edit</span>
							</button>

							<!-- Delete button -->
							<button
								*ngIf="isEditable() && !articleGroup?.isPromo && !hideRemoveItem"
								class="edit-btn"
								(click)="delete()"
								aria-label="Remove item"
								tabindex="0"
							>
								<ion-icon src="../../../assets/dean_and_david/delete_article.svg" aria-hidden="true"> </ion-icon>
								<span class="visually-hidden">Remove</span>
							</button>
						</div>
					</div>
				</ion-col>
			</ion-row>

			<!-- Product options -->
			<ion-row>
				<div class="flex-text" aria-label="Item options">
					<ng-container *ngFor="let group of articleGroup.groups">
						<ion-row *ngIf="!hiddenInCart(group.article)" class="option-name-row">
							<ion-col class="ion-no-padding" size="12">
								<p class="option-name">
									<span class="option-quantity"></span>{{ group.article.name | langObservable | async }}
									<ng-container *ngIf="priceOfOption(group) > 0">
										<span class="option-price">+{{ numberToCurrency(priceOfOption(group), order.currency) }}</span>
									</ng-container>
								</p>
							</ion-col>
						</ion-row>
					</ng-container>

					<!-- Item note -->
					<ion-row class="note" *ngIf="articleGroup.note && articleGroup.note.length > 0">
						<span class="note-text">{{ 'order_list.note_prefix' | translate }} {{ articleGroup.note }}</span>
					</ion-row>
				</div>
			</ion-row>

			<!-- Price and quantity controls -->
			<ion-row class="price-quantity-row">
				<!-- Item price -->
				<ion-col size="6" class="center-vertical">
					<div class="flex center-vertical">
						<h3 class="article-price" aria-label="Price">
							{{ numberToCurrency(articleGroupPrice, order.currency) }}
						</h3>
					</div>
				</ion-col>

				<!-- Quantity selector -->
				<ion-col size="6">
					<div class="quantity-selector" *ngIf="!articleGroup?.isPromo" role="group" aria-label="Quantity selector">
						<!-- Decrease quantity button -->
						<button
							class="quantity-btn decrease-btn"
							(click)="remove()"
							[attr.aria-label]="'Decrease quantity of ' + (articleGroup.article.name | langObservable | async)"
							tabindex="0"
						>
							<ion-icon src="../../../assets/dean_and_david/minus.svg" aria-hidden="true"> </ion-icon>
						</button>

						<!-- Quantity display -->
						<p class="quantity" aria-live="polite" aria-atomic="true">{{ articleGroup.quantity }}</p>

						<!-- Increase quantity button -->
						<button
							class="quantity-btn increase-btn"
							(click)="add()"
							[attr.aria-label]="'Increase quantity of ' + (articleGroup.article.name | langObservable | async)"
							tabindex="0"
						>
							<ion-icon src="../../../assets/dean_and_david/plus.svg" aria-hidden="true"> </ion-icon>
						</button>
					</div>
				</ion-col>
			</ion-row>
		</ion-col>
	</ion-row>
</div>
